<div class="main-container">
  <p-dialog header="Select File Type to request" [(visible)]="creatingEmptyIndividualFile" [modal]="true">
    <div class="file-type-container">
      <p-dropdown [options]="bookingService.bookingFileTypes" optionLabel="name" [(ngModel)]="selectedFileType">
      </p-dropdown>
      <p-button label="Confirm" (onClick)="addEmptyIndividualFile()"></p-button>
    </div>
  </p-dialog>
  <p-dialog header="Select Files to attach" [modal]="true" [(visible)]="bookingEmailService.displayFileAttachmentForm">
    <table class="file-import-table">
      <tr>
        <th>File name</th>
        <th>File type</th>
      </tr>
      <tr *ngFor="let form of bookingEmailService.fileAttachmentForm" [formGroup]="form">
        <td class="file-import-table-cell">
          <p-checkbox formControlName="isSelected" [binary]="true"
            (onChange)="bookingEmailService.updateFilesToAttach(form)">
          </p-checkbox>
          <span>{{form.value.file.name}}</span>
        </td>
        <td class="file-import-table-cell">
          {{form.value.file.documentType?.name}}
        </td>
      </tr>
    </table>
    <p-button label="confirm" (onClick)="bookingEmailService.closeFileAttachmentDialog()"></p-button>
  </p-dialog>
  <div class="pre-confirmation-container">
    <h3 class="title">
      Pre-confirmation
    </h3>
    <div>
      <p-table [value]="bookingService.preConfirmations">
        <ng-template pTemplate="header">
          <tr>
            <th>
              Created
            </th>
            <th>
              Created By
            </th>
            <th>
              Sent to client
            </th>
            <th>
              Sent to client by
            </th>
            <th>
              Action
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-preconf>
          <tr>
            <td>{{preconf.created | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
            <td>{{preconf.createdBy.name}}</td>
            <td>{{preconf.sentDate | date: 'dd/MM/yyyy'}}</td>
            <td><span *ngIf="preconf.sentBy">{{preconf.sentBy.name}}</span></td>
            <td>
              <div class="file-action-button-container">
                <p-button icon="pi pi-file-pdf" (onClick)="downloadPreConfirmationPdf(preconf)"></p-button>
                <p-button icon="pi pi-envelope" (onClick)="createEmailFormWithPreConfirmation(preconf)">
                </p-button>
                <a routerLink="/management/booking-pre-confirmation-preview/{{preconf.id}}" target="_blank">
                  <p-button icon="pi pi-search"></p-button>
                </a>
                <p-button *ngIf="preconf.sent==null && preconf.createdBy.name == userService.userName"
                  styleClass="p-button-danger" icon="pi pi-trash" (onClick)="deletePreConfirmation(preconf.id)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr class="no-record-tr">
            <td colspan="5">
              <div class="no-record-row" (click)="activatePreConfirmationForm()">
                <p class="no-record-message">
                  Add record
                </p>
                <div class="icon-wrap">
                  <i class="pi pi-plus"></i>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="booking-reports-container">
    <h3 class="title">
      Generated Documents
    </h3>
    <div>
      <p-table [value]="bookingService.bookingReports">
        <ng-template pTemplate="header">
          <tr>
            <th>
              Name
            </th>
            <th>
              Created
            </th>
            <th>
              Created By
            </th>
            <th>
              Sent to client
            </th>
            <th>
              Sent to client by
            </th>
            <th>
              Action
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-bookingReport>
          <tr>
            <td>
              {{bookingReport.fileName | shortStr: '29'}}
            </td>
            <td>{{bookingReport.created | date: 'dd/MM/yyyy HH:mm'}}</td>
            <td>{{bookingReport.createdBy.name}}</td>
            <td>{{bookingReport.sent | date: 'dd/MM/yyyy'}}</td>
            <td><span *ngIf="bookingReport.sentBy">{{bookingReport.sentBy.name}}</span></td>
            <td>
              <div class="file-action-button-container">
                <p-button icon="pi pi-file-pdf" (onClick)="downloadReport(bookingReport)"></p-button>
                <p-button *ngIf="bookingReport.bookingReportTemplate" icon="pi pi-envelope"
                  (onClick)="createEmailFormWithBookingReport(bookingReport)"></p-button>
                <a routerLink="/management/booking-report-preview/{{bookingReport.id}}" target="_blank">
                  <p-button icon="pi pi-search"></p-button>
                </a>
                <p-button *ngIf="bookingReport.sent==null && bookingReport.createdBy.name == userService.userName"
                  styleClass="p-button-danger" icon="pi pi-trash" (onClick)="deleteBookingReport(bookingReport)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-table [value]="bookingConfirmations">
        <ng-template pTemplate="body" let-confirmation>
          <tr>
            <td>
              Booking Confirmation
            </td>
            <td>
              {{confirmation.created | date: 'dd/MM/yyyy HH:mm'}}
            </td>
            <td>
              {{confirmation.createdBy}}
            </td>
            <td>
              {{confirmation.lastSent | date: 'dd/MM/yyyy'}}
            </td>
            <td>
              {{confirmation.lastSentBy}}
            </td>
            <td class="file-action-button-container">
              <p-button icon="pi pi-file-pdf" (onClick)="downloadConfirmationPdf(confirmation)"></p-button>
              <p-button icon="pi pi-envelope" (onClick)="createEmailFormWithBookingConfirmation(confirmation)">
              </p-button>
              <p-button icon="pi pi-search" (onClick)="navigateToConfirmationPreview(confirmation)"></p-button>
              <p-button *ngIf="confirmation.lastSent==null && confirmation.createdBy == userService.userName"
                styleClass="p-button-danger" icon="pi pi-trash" (onClick)="deleteBookingConfirmation(confirmation)">
              </p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-table [value]="bookingFinalConfirmations">
        <ng-template pTemplate="body" let-finalConfirmation>
          <tr>
            <td>
              Final Confirmation
            </td>
            <td>
              {{finalConfirmation.created | date: 'dd/MM/yyyy HH:mm'}}
            </td>
            <td>
              {{finalConfirmation.createdBy}}
            </td>
            <td>{{finalConfirmation.lastSent | date: 'dd/MM/yyyy' }}</td>
            <td>
              {{finalConfirmation.lastSentBy}}
            </td>
            <td class="file-action-button-container">
              <p-button icon="pi pi-file-pdf" (onClick)="downloadFinalConfirmationPdf(finalConfirmation)"></p-button>
              <p-button icon="pi pi-envelope"
                (onClick)="createEmailFormWithBookingFinalConfirmation(finalConfirmation)"></p-button>
              <p-button icon="pi pi-search" (onClick)="navigateToFinalConfirmationPreview(finalConfirmation)">
              </p-button>
              <p-button *ngIf="finalConfirmation.lastSent==null && finalConfirmation.createdBy == userService.userName"
                styleClass="p-button-danger" icon="pi pi-trash"
                (onClick)="deleteBookingFinalConfirmation(finalConfirmation)">
              </p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="select-generate-document-container">
      <p-dropdown placeholder="Select Document type" [options]="bookingService.pdfTemplates"
        [(ngModel)]="selectedDocumentTemplate" optionLabel="name" (onChange)="reportDocumentTypeChange($event.value)"
        scrollHeight="600px" [style]="{'width':'400px'}" [filter]="true" filterBy="name">
      </p-dropdown>
      <p-button [disabled]="makingBookingReport" (onClick)="generateBookingDocument()" label="Generate document">
      </p-button>
      <p-button *ngIf="isFinalConfirmationTemplateSelected" label="Edit & Generate" (onClick)="editFinalConf()">
      </p-button>
      <p-progressSpinner *ngIf="makingBookingReport" [style]="{width: '36px', height: '36px'}">
      </p-progressSpinner>
    </div>
  </div>

  <p-dialog header="Edit Final Confirmation and Save" [modal]="true" [(visible)]="activeFinalConfEdit">
    <div>
      <p>
        <strong>Warning:</strong>
        Warning: Editing reports is experimental. Look at them before carefully before sending.
      </p>
    </div>
    <ckeditor [editor]="Editor" [(ngModel)]="editableFinalConfirmationHtmlString"></ckeditor>
    <p-button label="Generate" (onClick)="generateModifiedFinalConf()"></p-button>
  </p-dialog>

  <p-dialog header="Send this document by email" [modal]="true" [(visible)]="displayEmailForm"
    (onHide)="resetEmailForms()" [focusOnShow]="false">
    <div [formGroup]="bookingReportEmailForm" class="email-form-container" *ngIf="bookingReportEmailForm">
      <div class="email-templates-container">
        <p>Send email to...</p>
        <div>
          <p-progressSpinner *ngIf="loadingSelectedEmailTemplate" [style]="{width: '36px', height: '36px'}">
          </p-progressSpinner>
          <p-dropdown [options]="bookingEmailService.emailTemplates" optionLabel="name" placeholder="templates"
            [filter]="true" [scrollHeight]="dropdownScrollHeight" (onChange)="selectEmailTemplate($event.value)"
            [style]="{width: '400px'}">
          </p-dropdown>
        </div>
      </div>

      <div *ngIf="bookingReportEmailForm.get('isStudentDocument')!.value" class="student-recipient-container">
        Student addresses
        <div *ngFor="let form of studentRecipients.controls" [formGroup]="form | formGroup" class="student-recipient-item">
          <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}</span>
          <span>{{form.value.typeName}}</span>
        </div>
        <div class="vivawallet-menu-container">
          <p-checkbox formControlName="withVivawalletPaymentLink" [binary]="true"
            (onChange)="onVivawalletChange($event, bookingReportEmailForm)"></p-checkbox> <span>Add Vivawallet payment
            link</span>
          <span *ngIf="vivawalletOrderAmount"> {{vivawalletOrderAmount}} € will be on the checkout screen</span>
        </div>
      </div>
      <div *ngIf="bookingReportEmailForm.get('isSchoolDocument')!.value" class="school-recipients-container">
        School contacts
        <div *ngFor="let form of schoolRecipients.controls" [formGroup]="form | formGroup" class="school-recipient-item">
          <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}</span>
          <span>{{form.value.typeName}}</span>
        </div>
      </div>
      <div class="subject-container">
        <p>Subject:</p> <input pInputText formControlName="subject" class="subject-input">
      </div>
      <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
      <div>
        <div class="email-send-buttons-container">
          <div>
            <p-button *ngIf="bookingReportEmailForm.get('isSchoolDocument')!.value" icon="pi pi-paperclip"
              label="Add files"
              (onClick)="bookingEmailService.openSchoolFileAttachmentDialog(bookingService.booking.id!)"></p-button>
            <p-button *ngIf="!bookingReportEmailForm.get('isSchoolDocument')!.value" icon="pi pi-paperclip"
              label="Add files"
              (onClick)="bookingEmailService.openStudentFileAttachmentDialog(bookingService.booking.id!)">
            </p-button>
            <span *ngIf="bookingReportEmailForm.get('report')!.value">
              attachment: {{bookingReportEmailForm.get('report')!.value.fileName}}
            </span>
          </div>
          <p-progressSpinner *ngIf="sendingBookingReportByEmail" [style]="{width: '36px', height: '36px'}">
          </p-progressSpinner>
          <p-button [disabled]="sendingBookingReportByEmail || getEmailRecipients().length == 0" label="Send"
            (onClick)="sendReportByMail()"></p-button>
        </div>
        <div *ngIf="bookingEmailService.emailAttachmentFiles.length>0">
          extra attachment:
          <p *ngFor="let file of bookingEmailService.emailAttachmentFiles">
            {{file.name}}
          </p>
        </div>
        <div class="paste-pixel-checkbox-container">
          <p-checkbox formControlName="withPastePixel" [binary]="true"></p-checkbox>
          <span>Use Paste Pixel</span>
        </div>
      </div>
    </div>
  </p-dialog>

  <p-dialog header="Send this document by email" [modal]="true" [(visible)]="displayEmailFormWithBookingConfirmation"
    (onHide)="resetEmailForms()" [focusOnShow]="false">
    <div [formGroup]="bookingConfirmationEmailForm" class="email-form-container" *ngIf="bookingConfirmationEmailForm">
      <div class="email-templates-container">
        <p>Send email to...</p>
        <div>
          <p-progressSpinner *ngIf="loadingSelectedEmailTemplate" [style]="{width: '36px', height: '36px'}">
          </p-progressSpinner>
          <p-dropdown [options]="bookingEmailService.emailTemplates" optionLabel="name" placeholder="templates"
            [style]="{'width':'400px'}" [filter]="true" filterBy="name" [scrollHeight]="dropdownScrollHeight"
            (onChange)="selectEmailTemplate($event.value)">
          </p-dropdown>
        </div>
      </div>
      <div class="student-recipient-container">
        Student address:
        <div *ngFor="let form of bookingConfirmationStudentRecipients.controls" [formGroup]="form | formGroup"
          class="student-recipient-item">
          <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}</span>
          <span>{{form.value.typeName}}</span>
        </div>
      </div>
      <div class="vivawallet-menu-container">
        <p-checkbox formControlName="withVivawalletPaymentLink" [binary]="true"
          (onChange)="onVivawalletChange($event, bookingConfirmationEmailForm)"></p-checkbox> <span>Add Vivawallet
          payment link</span>
        <span *ngIf="vivawalletOrderAmount"> {{vivawalletOrderAmount}} € will be on the checkout screen</span>
      </div>
      <div class="subject-container">
        <p>Subject:</p> <input pInputText formControlName="subject" class="subject-input">
      </div>
      <ckeditor [editor]="Editor" formControlName="body"></ckeditor>

      <div>
        <div class="email-send-buttons-container">
          <div>
            <p-button [disabled]="sendingBookingReportByEmail" icon="pi pi-paperclip" label="Add files"
              (onClick)="bookingEmailService.openStudentFileAttachmentDialog(bookingService.booking.id!)">
            </p-button>
            <span>
              attachment: {{bookingConfirmationEmailForm.get('confirmation')!.value.fileName}}
            </span>
          </div>
          <p-progressSpinner *ngIf="sendingBookingReportByEmail" [style]="{width: '36px', height: '36px'}">
          </p-progressSpinner>
          <p-button label="Send" [disabled]="sendingBookingReportByEmail"
            (onClick)="sendBookingConfirmationByMail(bookingConfirmationEmailForm.value.confirmation)"></p-button>
        </div>
        <div>
          <span>
            Signature:
          </span>
          <p-dropdown placeholder="Signature" formControlName="signature"
            [options]="emailSignatureService.emailSignatures" optionLabel="language.name"></p-dropdown>
        </div>
        <div *ngIf="bookingEmailService.emailAttachmentFiles.length>0">
          extra attachment:
          <p *ngFor="let file of bookingEmailService.emailAttachmentFiles">
            {{file.name}}
          </p>
        </div>
        <div class="paste-pixel-checkbox-container">
          <p-checkbox formControlName="withPastePixel" [binary]="true"></p-checkbox>
          <span>Use Paste Pixel</span>
        </div>
      </div>
    </div>
  </p-dialog>

  <p-dialog header="Send this document by email" [modal]="true" [(visible)]="displayEmailFormWithBookingFinalConfirmation"
    (onHide)="resetEmailForms()" [focusOnShow]="false">
    <div [formGroup]="bookingFinalConfirmationEmailForm" class="email-form-container"
      *ngIf="bookingFinalConfirmationEmailForm">
      <div class="email-templates-container">
        <p>Send email to...</p>
        <div>
          <p-progressSpinner *ngIf="loadingSelectedEmailTemplate" [style]="{width: '36px', height: '36px'}">
          </p-progressSpinner>
          <p-dropdown [options]="bookingEmailService.emailTemplates" optionLabel="name" placeholder="templates"
            [filter]="true" filterBy="name" [scrollHeight]="dropdownScrollHeight" (onChange)="selectEmailTemplate($event.value)"
            [style]="{'width':'400px'}">
          </p-dropdown>
        </div>
      </div>

      <div class="student-recipient-container">
        Student addresses:
        <div *ngFor="let form of finalConfirmationStudentRecipients.controls" [formGroup]="form | formGroup"
          class="student-recipient-item">
          <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}</span>
          <span>{{form.value.typeName}}</span>
        </div>
      </div>
      <div class="vivawallet-menu-container">
        <p-checkbox formControlName="withVivawalletPaymentLink" [binary]="true"
          (onChange)="onVivawalletChange($event, bookingFinalConfirmationEmailForm)"></p-checkbox> <span>Add Vivawallet
          payment link</span>
        <span *ngIf="vivawalletOrderAmount"> {{vivawalletOrderAmount}} € will be on the checkout screen</span>
      </div>
      <div class="subject-container">
        <p>Subject:</p> <input pInputText formControlName="subject" class="subject-input">
      </div>
      <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
      <div>
        <div class="email-send-buttons-container">
          <div>
            <p-button icon="pi pi-paperclip" label="Add files" [disabled]="sendingBookingReportByEmail"
              (onClick)="bookingEmailService.openStudentFileAttachmentDialog(bookingService.booking.id!)">
            </p-button>
            <span>
              attachment: {{bookingFinalConfirmationEmailForm.get('finalConfirmation')!.value.fileName}}
            </span>
          </div>
          <p-progressSpinner *ngIf="sendingBookingConfirmationByEmail" [style]="{width: '36px', height: '36px'}">
          </p-progressSpinner>
          <p-button label="Send" [disabled]="sendingBookingReportByEmail"
            (onClick)="sendBookingFinalConfirmationByMail(bookingFinalConfirmationEmailForm.value.finalConfirmation)">
          </p-button>
        </div>
        <div>
          <span>
            Signature:
          </span>
          <p-dropdown placeholder="Signature" formControlName="signature"
            [options]="emailSignatureService.emailSignatures" optionLabel="language.name"></p-dropdown>
        </div>
        <div *ngIf="bookingEmailService.emailAttachmentFiles.length>0">
          extra attachment:
          <p *ngFor="let file of bookingEmailService.emailAttachmentFiles">
            {{file.name}}
          </p>
        </div>
        <div class="paste-pixel-checkbox-container">
          <p-checkbox formControlName="withPastePixel" [binary]="true"></p-checkbox>
          <span>Use Paste Pixel</span>
        </div>
      </div>
    </div>
  </p-dialog>

  <div class="imported-files-container">
    <h3 class="title">
      Imported Global/School Files
    </h3>
    <div>
      <div class="import-school-global-file-buttons-container">
        <p-button label="import school files" (onClick)="openSchoolFilesImportDialog()"></p-button>
        <p-button label="import global files" (onClick)="openGlobalFilesImportDialog()"></p-button>
      </div>
      <p-table [value]="importedGlobalFiles">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>
              Type
            </th>
            <th width="100">
              Actions
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-globalFile>
          <tr>
            <td>
              <a id="download-link" (click)="downloadGlobalFile(globalFile)">
                {{globalFile.fileName | shortStr: '60'}}
              </a>
            </td>
            <td>
              <p *ngIf="globalFile.fileType">
                {{globalFile.fileType.name}}
              </p>
            </td>
            <td>
              <p-button icon="pi pi-trash" styleClass="p-button-danger"
                (onClick)="deleteImportedGlobalFile(globalFile)"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-table [value]="importedSchoolFiles">
        <ng-template pTemplate="body" let-schoolFile>
          <tr>
            <td>
              <a id="download-link" (click)="downloadSchoolFile(schoolFile)">
                {{schoolFile.fileName | shortStr: '60'}}
              </a>
            </td>
            <td>
              <p *ngIf="schoolFile.fileType">
                {{schoolFile.fileType.name}}
              </p>
            </td>
            <td width="100">
              <p-button icon="pi pi-trash" styleClass="p-button-danger"
                (onClick)="deleteImportedSchoolFile(schoolFile)"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <p-dialog header="Send this pre confirmation by email" [modal]="true" [(visible)]="displayPreConfirmationEmailForm"
      (onHide)="resetPreConfirmationEmailForm()" [focusOnShow]="false">
      <div [formGroup]="preConfirmationEmailForm" class="email-form-container" *ngIf="preConfirmationEmailForm">
        <div class="email-templates-container">
          <p>Send email to...</p>
          <div>
            <p-progressSpinner *ngIf="loadingSelectedEmailTemplate" [style]="{width: '36px', height: '36px'}">
            </p-progressSpinner>
            <p-dropdown [options]="bookingEmailService.emailTemplates" optionLabel="name" placeholder="templates"
              [filter]="true" filterBy="name" [scrollHeight]="dropdownScrollHeight" (onChange)="selectEmailTemplate($event.value)"
              [style]="{'width':'400px'}">
            </p-dropdown>
          </div>
        </div>
        <div class="student-recipient-container">
          Student address:
          <div *ngFor="let form of bookingPreConfirmationStudentRecipients.controls" [formGroup]="form | formGroup"
            class="student-recipient-item">
            <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}</span>
            <span>{{form.value.typeName}}</span>
          </div>
          <div>
            <div class="vivawallet-menu-container">
              <p-checkbox formControlName="withVivawalletPaymentLink" [binary]="true"
                (onChange)="onVivawalletChange($event, preConfirmationEmailForm)"></p-checkbox> <span>Add Vivawallet
                payment link</span>
              <span *ngIf="vivawalletOrderAmount"> {{vivawalletOrderAmount}} € will be on the checkout screen</span>
            </div>
            <div>
              <p *ngIf="hasVivawalletPaymentOrder">This booking has a payment order already: {{vivawalletCheckourUrl}}
              </p>
            </div>
          </div>
        </div>
        <div class="subject-container">
          <p>Subject:</p> <input pInputText formControlName="subject" class="subject-input">
        </div>
        <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
        <div>
          <div class="email-send-buttons-container">
            <div>
              <span>
                attachment: {{preConfirmationEmailForm.get('report')!.value?.fileName}}
              </span>
            </div>
            <app-email-sending-spinner *ngIf="sendingBookingPreConfirmationByEmail"></app-email-sending-spinner>
            <p-button [disabled]="sendingBookingPreConfirmationByEmail " label="Send"
              (onClick)="sendPreConfirmationByEmail()"></p-button>
          </div>
          <div>
            <p>
              <p-button label="Add files"
                (onClick)="bookingEmailService.openStudentFileAttachmentDialog(bookingService.booking!.id!)"></p-button>
            </p>
          </div>
          <div>
            <span>
              Signature:
            </span>
            <p-dropdown placeholder="Signature" formControlName="signature"
              [options]="emailSignatureService.emailSignatures" optionLabel="language.name"></p-dropdown>
          </div>
          <div *ngIf="bookingEmailService.emailAttachmentFiles.length>0">
            extra attachment:
            <p *ngFor="let file of bookingEmailService.emailAttachmentFiles">
              {{file.name}}
            </p>
          </div>
          <div class="paste-pixel-checkbox-container">
            <p-checkbox formControlName="withPastePixel" [binary]="true"></p-checkbox>
            <span>Use Paste Pixel</span>
          </div>
        </div>
      </div>
    </p-dialog>

    <p-dialog header="import school files" [(visible)]="activeSchoolFileImportDialog" [modal]="true"
      (onShow)="initSchoolFileImportDialog()">
      <p *ngIf="!loadingSchoolFiles && schoolFiles.length == 0">No file from this school</p>
      <div class="file-list-container">
        <table class="file-import-table">
          <tr>
            <th>
              Name
            </th>
            <th>
              File type
            </th>
          </tr>
          <tr *ngFor="let file of schoolFiles; let index = index" [formGroup]="schoolFilesImportForm[index]">
            <td class="file-import-table-cell">
              <p-checkbox [binary]="true" formControlName="importThisFile"></p-checkbox>
              <span>
                {{file.name}}
              </span>
            </td>
            <td class="file-import-table-cell">
              {{file.fileType?.name}}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <p-button label="Import selected files" (onClick)="importSchoolFiles()"></p-button>
      </div>
    </p-dialog>

    <p-dialog header="import global files" [(visible)]="activeGlobalFileImportDialog" [modal]="true"
      (onShow)="initGlobalFileImportDialog()">
      <p *ngIf="!loadingGlobalFiles && globalFiles.length == 0">No file is available</p>
      <div class="file-list-container">
        <table>
          <tr>
            <th>
              Name
            </th>
            <th>
              File type
            </th>
          </tr>
          <tr *ngFor="let file of globalFiles; let index = index" [formGroup]="globalFilesImportForm[index]">
            <td class="file-import-table-cell">
              <p-checkbox [binary]="true" formControlName="importThisFile"></p-checkbox>
              <span>
                {{file.name}}
              </span>
            </td>
            <td class="file-import-table-cell">
              {{file.fileType?.name}}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <p-button label="Import selected files" (onClick)="importGlobalFiles()"></p-button>
      </div>
    </p-dialog>
    <p-dialog header="import school files" [(visible)]="activeSchoolFileToBeCompletedImportDialog" [modal]="true"
      (onShow)="initSchoolFileImportDialog()">
      <p *ngIf="!loadingSchoolFiles && schoolFiles.length == 0">No file from this school</p>
      <div class="file-list-container">
        <div *ngFor="let file of schoolFiles; let index = index" [formGroup]="schoolFilesImportForm[index]">
          <p-checkbox [binary]="true" formControlName="importThisFile"></p-checkbox>
          <span>
            {{file.name}}
          </span>
        </div>
      </div>
      <div>
        <p-button label="Import selected files" (onClick)="importSchoolFiles()"></p-button>
      </div>
    </p-dialog>

    <p-dialog header="import global files" [(visible)]="activeGlobalFileToBeCompletedImportDialog" [modal]="true"
      (onShow)="initGlobalFileImportDialog()">
      <p *ngIf="!loadingGlobalFiles && globalFiles.length == 0">No file is available</p>
      <div class="file-list-container">
        <div *ngFor="let file of globalFiles; let index = index" [formGroup]="globalFilesImportForm[index]">
          <p-checkbox [binary]="true" formControlName="importThisFile"></p-checkbox>
          <span>
            {{file.name}}
          </span>
        </div>
      </div>
      <div>
        <p-button label="Import selected files" (onClick)="importGlobalFiles()"></p-button>
      </div>
    </p-dialog>
  </div>
  <div class="individual-files-container">
    <h3 class="title">
      Other Files
    </h3>
    <p-table [value]="individualBookingFiles">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>
            Type
          </th>
          <th width="100">
            Actions
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bookingFile>
        <tr>
          <td>
            <a id="download-link" (click)="downloadIndividualFile(bookingFile)">
              {{bookingFile.fileName | shortStr: '60'}}
            </a>
          </td>
          <td>
            <p-dropdown [options]="bookingService.bookingFileTypes" optionLabel="name" placeholder="---"
              [(ngModel)]="bookingFile.bookingFileType" dataKey="id" [style]="{'width': '300px', 'min-width': '180px'}"
              [filter]="true" filterBy="name" [scrollHeight]="dropdownScrollHeight" (onChange)="updateIndividualFile(bookingFile)" appendTo="body">
            </p-dropdown>
          </td>
          <td>
            <p-button icon="pi pi-trash" styleClass="p-button-danger"
              (onClick)="deleteImportedIndividualFile(bookingFile)"></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-fileUpload #fileForm [customUpload]="true" [multiple]="true" (uploadHandler)="uploadIndividualFile($event.files, fileForm)"
      [maxFileSize]="16000000">
    </p-fileUpload>
    <div class="import-file-buttons-container">
      <p-button label="Request file" (onClick)="openEmptyIndividualFileCreationDialog()"></p-button>
    </div>
  </div>
</div>